// extracted by mini-css-extract-plugin
module.exports = {"bottomAnchor":"Login_bottomAnchor__Se5Uw"};